<script lang="ts">
  export interface FieldReadonlyProps {
    label: string
    value?: string | null
    noValueText?: string
    href?: string
    class?: HTMLAttributes['class']
  }
</script>

<script setup lang="ts">
  import { onMounted, reactive } from 'vue'
  import { globalUtils } from '@gat-ship/utils'
  import type { HTMLAttributes } from 'vue'
  import { cn } from '../../lib/utils'

  const props = withDefaults(defineProps<FieldReadonlyProps>(), {
    noValueText: '-'
  })

  const emit = defineEmits<{
    (e: 'copy', value: string): void
    (e: 'update'): void
  }>()

  const boundEvents = reactive({
    copy: false,
    update: false
  })

  onMounted(() => {
    boundEvents.copy = globalUtils.functions.components.hasEmitListener('copy')
    boundEvents.update =
      globalUtils.functions.components.hasEmitListener('update')
  })
</script>
<template>
  <div class="group relative">
    <div
      class="text-xs font-medium tracking-wider text-neutral-700 dark:text-neutral-200"
    >
      {{ label }}
    </div>
    <div class="mt-1 text-sm font-medium text-neutral-950">
      <a
        v-if="href && value"
        :href="href"
        class="hover:text-link/80"
        @click.stop
        >{{ value }}</a
      >
      <div
        v-else
        :class="cn('text-sm font-medium text-neutral-950', props.class)"
      >
        {{ value ?? noValueText }}
      </div>
    </div>
    <div
      class="absolute right-0 top-1/2 hidden -translate-y-1/2 gap-2 px-1.5 group-hover:flex group-hover:items-center group-hover:justify-center"
    >
      <gat-button
        v-if="value && boundEvents.copy"
        icon="Copy"
        size="icon"
        variant="outline"
        class="size-6"
        :icon-props="{ class: 'size-3' }"
        @click="emit('copy', value)"
      />
      <gat-button
        v-if="boundEvents.update"
        icon="Edit"
        size="icon"
        variant="outline"
        class="size-6"
        :icon-props="{ class: 'size-3' }"
        @click="emit('update')"
      />
    </div>
  </div>
</template>
